import { render, staticRenderFns } from "./MainWorks.vue?vue&type=template&id=619a3ddc&scoped=true&"
import script from "./MainWorks.vue?vue&type=script&lang=js&"
export * from "./MainWorks.vue?vue&type=script&lang=js&"
import style0 from "./MainWorks.vue?vue&type=style&index=0&id=619a3ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a3ddc",
  null
  
)

export default component.exports